import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "../components/Seo";
import { api } from "../lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/content/blog").then((r) => setPosts(r.data)).catch(() => {}); }, []);

  return (
    <>
      <Seo title="Blog & News | Car To Cash" description="Guides and news on selling your car for cash, car valuations, finance payouts and free car removal across Melbourne & Victoria." canonical="https://cartocash.com.au/blog" />
      <section className="noise-dark text-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-16">
          <h1 className="font-display text-4xl sm:text-5xl font-black">Blog &amp; news</h1>
          <p className="mt-3 text-white/75 text-lg">Tips and guides to help you sell your car the smart way.</p>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-4 sm:px-6 py-16 grid gap-6 md:grid-cols-3" data-testid="blog-grid">
        {posts.map((p) => (
          <Link key={p.id} to={`/blog/${p.slug}`} className="group rounded-2xl border border-brand-line bg-white overflow-hidden hover:-translate-y-1 hover:shadow-lg transition-all" data-testid={`blog-card-${p.slug}`}>
            <div className="h-44 overflow-hidden"><img src={p.cover_image} alt={p.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-300" /></div>
            <div className="p-6">
              <h2 className="font-display text-lg font-extrabold text-brand-navy">{p.title}</h2>
              <p className="mt-2 text-sm text-brand-muted line-clamp-3">{p.excerpt}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-bold text-brand-navy group-hover:text-brand-gold transition-colors">Read more <ArrowRight className="h-4 w-4" /></span>
            </div>
          </Link>
        ))}
      </section>
    </>
  );
}
